class BaseStyler {

	public defaultLabelSize: number = 16;
}

export default BaseStyler;
